export default{

    parseStringToNumber(str){
        if(str.length==0) return false
        str = str.toString();

        if (str.indexOf(',') > -1) {
            str = str.replace(',', '.');
        }
        return str = parseFloat(str);
    }

}


// WEBPACK FOOTER //
// ./src/utilities/NumberUilities.js